import { IQuotation } from 'app/shared/model/quotation.model';

export interface IBookingConfirmation {
  id?: any;
  quotationId?: any;
  lpoReference?: string | ' ';
  contractReference?: string | ' ';
  createdBy?: string;
  createdDate?: string;
  lastModifiedBy?: string;
  lastModifiedDate?: string;

  quotation?: IQuotation;
  transactionRefNo?: string;
  customerName?: string;
  bankName?: string;
  amount?: number | 0;
  buyCurrency?: string;
  amountTransferred?: boolean;
}

export const defaultValue: Readonly<IBookingConfirmation> = {
  id: '',
  quotationId: '',
  lpoReference: '',
  contractReference: '',
  createdBy: '',
  createdDate: null,
  lastModifiedBy: '',
  lastModifiedDate: null,
};
